<script lang="ts">
  import Layers from "@lucide/svelte/icons/layers";
</script>

<Layers {...$$restProps} style="transform: rotate(-90deg);" />
